export const isPremiumUser = () => {
  if (typeof document === "undefined") return false;
  return document.cookie.split(";").some((c) => {
    const [key, value] = c.trim().split("=");
    return key === "ugg_premium" && value === "1";
  });
};
